import React from 'react';
import { DatePicker as AntDatePicker, ConfigProvider, theme } from 'antd';
import dayjs from 'dayjs';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * Isolated Ant Design DatePicker Component
 * Does not affect existing code - use only where needed
 */
const AntDatePickerComponent = ({ 
  value, 
  onChange, 
  placeholder = 'Select date',
  format = 'YYYY-MM-DD',
  disabled = false,
  className = '',
  style = {},
  ...props 
}) => {
  const { mode } = useTheme();
  const isDark = mode === 'dark';

  const themeConfig = {
    algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
    token: {
      colorPrimary: '#3b82f6',
      borderRadius: 12,
      colorBgContainer: isDark ? 'rgba(0, 0, 0, 0.95)' : '#ffffff',
      colorBgElevated: isDark ? 'rgba(0, 0, 0, 0.95)' : '#ffffff',
      colorBorder: isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(15, 23, 42, 0.15)',
      colorText: isDark ? '#ffffff' : '#0f172a',
      colorTextPlaceholder: isDark ? 'rgba(255, 255, 255, 0.4)' : 'rgba(100, 116, 139, 0.6)',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      fontSize: 14,
      controlHeight: 40,
    },
    components: {
      DatePicker: {
        controlHeight: 40,
        colorBgContainer: isDark ? 'rgba(0, 0, 0, 0.95)' : '#ffffff',
        colorBgElevated: isDark ? 'rgba(0, 0, 0, 0.95)' : '#ffffff',   // ADD THIS LINE
        addonBg: isDark ? 'rgba(0, 0, 0, 0.95)' : '#ffffff',
      }
    }
  };

  return (
    <ConfigProvider theme={themeConfig}>
      <AntDatePicker
        value={value ? dayjs(value) : null}
        
        onChange={(date, dateString) => {
          if (onChange) {
            onChange(date ? date.toDate() : null, dateString);
          }
        }}
        placeholder={placeholder}
        format={format}
        disabled={disabled}
        className={className}
        style={{ width: '100%', ...style }}
        popupStyle={{ width: 'fit-content', minWidth: '290px' }}  // ← ADD THIS LINE
        {...props}
      />
    </ConfigProvider>
  );
};

export default AntDatePickerComponent;
export { dayjs };
